import React from 'react';
import ProjectName from './project-name';
import { SingleValueTypography } from './styles';

function SingleValue(props) {
  return (
    <SingleValueTypography
      {...props.innerProps}
      disabled={props.selectProps.isDisabled}
      style={props.selectProps.isDisabled ? { color: props.theme.colors.neutral30 } : {}}
    >
      {props.children}
      {props.selectProps.showProjectName ?
        <ProjectName project={props.data?.project} /> : null}
    </SingleValueTypography>
  );
}

export default SingleValue;
